import {
  Analytics
} from "./chunk-YBHTLIZ2.js";
import {
  toKebabCase
} from "./chunk-QL3LGFZE.js";

// src/rudderstack.ts
var CHERRY_LANE_ADDRESS = {
  city: "New York",
  country: "US",
  full: "38 Commerce St, New York, NY",
  geo: { lat: 40.730018, lon: -74.002605 },
  state: "NY",
  street: "38 Commerce St",
  zip: "10014"
};
function formatShowtimeTime(isoString) {
  const date = new Date(isoString);
  const etOptions = { timeZone: "America/New_York" };
  const dateStr = new Intl.DateTimeFormat("en-US", {
    ...etOptions,
    month: "numeric",
    day: "numeric",
    year: "2-digit"
  }).format(date);
  const timeStr = new Intl.DateTimeFormat("en-US", {
    ...etOptions,
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  }).format(date);
  return {
    date: dateStr,
    time: timeStr,
    timestamp: date.getTime()
  };
}
function showTracking(data) {
  return {
    name: "Product Viewed",
    props: {
      position: data.position,
      brand: "A24",
      category: data.category,
      currency: "USD",
      full_name: data.showName,
      name: data.showName,
      product_id: data.vivenuEventId,
      quantity: 1,
      tags: data.showName ? [`live-${toKebabCase(data.showName)}`] : []
    }
  };
}
function showtimeTracking(data) {
  return {
    name: "Showtime Clicked",
    props: {
      position: data.position,
      products: [
        {
          brand: "A24",
          category: data.category,
          currency: "USD",
          full_name: data.showName,
          name: data.showName,
          product_id: data.vivenuEventId,
          variant_id: data.vivenuPerformanceId,
          quantity: 1,
          tags: data.showName ? [`live-${toKebabCase(data.showName)}`] : []
        }
      ],
      showtime: {
        chain_name: "A24",
        address: CHERRY_LANE_ADDRESS,
        cinema_name: "Cherry Lane Theatre",
        id: data.vivenuPerformanceId,
        time: data.startDate ? formatShowtimeTime(data.startDate) : void 0
      },
      promotion_vendors: ["A24"]
    }
  };
}
function buildTicketProduct(ctx, ticket) {
  return {
    brand: "A24",
    category: ctx.category ? [ctx.category] : ["Theater Ticket"],
    currency: ctx.currency,
    full_name: ctx.showName,
    name: ctx.showName,
    order_id: ctx.orderId,
    price: ticket.price,
    product_id: ctx.vivenuEventId,
    variant_id: ctx.vivenuPerformanceId,
    purchase_type: "Purchase",
    quantity: 1,
    discount: ticket.discount,
    tags: ctx.showName ? [`live-${toKebabCase(ctx.showName)}`] : [],
    showtime: {
      chain_name: "A24",
      address: CHERRY_LANE_ADDRESS,
      cinema_name: "Cherry Lane Theatre",
      id: ctx.vivenuPerformanceId,
      time: ctx.startDate ? formatShowtimeTime(ctx.startDate) : void 0
    }
  };
}
function checkoutCompletedTracking(data) {
  return {
    name: "Checkout Completed",
    props: {
      brand: "A24",
      credit_amount: data.creditAmount,
      currency: data.currency,
      order_id: data.orderId,
      price: data.totalAmount,
      product_id: data.vivenuEventId,
      variant_id: data.vivenuPerformanceId,
      purchase_type: "Purchase",
      quantity: data.tickets.length,
      revenue: data.totalAmount,
      subtotal: data.regularPrice,
      tax: 0,
      total: data.totalAmount,
      products: data.tickets.map((ticket) => buildTicketProduct(data, ticket)),
      vendor: {
        balance_due: data.totalAmount,
        order_id: data.orderId
      },
      promotion_vendors: ["A24"]
    }
  };
}
function productCheckoutTracking(data) {
  return {
    name: "Product Checkout",
    props: {
      ...buildTicketProduct(data, {
        price: data.price,
        discount: data.discount
      }),
      promotion_vendors: ["A24"]
    }
  };
}
var dispatchRudderEvent = (event) => {
  switch (event.name) {
    // We only track the page event and the button click for shows browsed
    case "shows_browsed":
      break;
    case "show_viewed": {
      const tracking = showTracking(event.data);
      Analytics.track(tracking.name, { props: tracking.props });
      break;
    }
    case "seat_map_viewed": {
      const tracking = showtimeTracking(event.data);
      Analytics.track(tracking.name, { props: tracking.props });
      break;
    }
    case "checkout_completed": {
      const tracking = checkoutCompletedTracking(event.data);
      Analytics.track(tracking.name, { props: tracking.props });
      break;
    }
    case "product_checkout": {
      const tracking = productCheckoutTracking(event.data);
      Analytics.track(tracking.name, { props: tracking.props });
      break;
    }
    case "button_interaction":
      Analytics.track("Clicked", {
        props: { value: event.data.value, type: "button" }
      });
      break;
    case "link_interaction":
      Analytics.track("Clicked", {
        props: { value: event.data.value, type: "link" }
      });
      break;
  }
};

export {
  dispatchRudderEvent
};
